import React from 'react';
import TischOffensives from './TischOffensives';
import { OutdoorClusters, SkiClusters, BikeClusters } from './Clusters';
import { NavMenuModal, RowFlexBox, SpacingBox } from '../Components';
import { GenrePickerComponent } from './GenrePickerComponent';

const TopMenuItem = ({ children }) => (
  <SpacingBox marginRight="xl">{children}</SpacingBox>
);

const closeOnSelecting = (setIsOpen) => () => setIsOpen(false);

export const TopMenuModal = ({ setIsOpen, isOpen }) => {
  const onCancel = () => setIsOpen(false);

  return (
    <NavMenuModal onCancel={onCancel} isOpen={isOpen}>
      <div className="container-fluid margin-10p">
        <GenrePickerComponent onCancel={onCancel} />
        <RowFlexBox flex={1}>
          {/* <TopMenuItem> */}
          {/*   <NewSaleButton /> */}
          {/* </TopMenuItem> */}
          <TopMenuItem>
            <BikeClusters onSelectCluster={closeOnSelecting(setIsOpen)} />
          </TopMenuItem>
          <TopMenuItem>
            <OutdoorClusters onSelectCluster={closeOnSelecting(setIsOpen)} />
          </TopMenuItem>
          <TopMenuItem>
            <SkiClusters onSelectCluster={closeOnSelecting(setIsOpen)} />
          </TopMenuItem>
          <TopMenuItem>
            <TischOffensives onSelect={closeOnSelecting(setIsOpen)} />
          </TopMenuItem>
        </RowFlexBox>
      </div>
    </NavMenuModal>
  );
};
